module.exports = __webpack_public_path__ + "static/media/dessertphoto.7822007a.jpg";